import { getStatesApi } from '../services/authApi/userApi';

// US states are effectively static for the lifetime of a session, and this page can render
// several state pickers (StateSeeder) plus its own lookup — cache by page/perPage so they
// share one network request instead of each firing their own.
const cache = new Map();

export const getCachedStates = (page, perPage) => {
  const key = `${page}-${perPage}`;
  if (!cache.has(key)) {
    const promise = getStatesApi({ page, perPage }).catch((error) => {
      cache.delete(key); // allow a retry on failure instead of caching a rejection forever
      throw error;
    });
    cache.set(key, promise);
  }
  return cache.get(key);
};

// entityAddress.state comes back from the API as a human-readable state name (e.g.
// "California"), not a stateId — but StateSeeder's dropdown options key on the numeric
// stateId, so it can't be prefilled with the raw name. This resolves the name to its
// stateId via the same cached states list StateSeeder itself uses.
export const resolveStateId = async (stateName) => {
  if (!stateName) return undefined;
  if (/^\d+$/.test(stateName)) return Number(stateName);
  try {
    const resp = await getCachedStates(1, 100);
    const matched = resp?.data?.states?.find((item) => item?.name?.toLowerCase() === stateName.toLowerCase());
    return matched?.stateId;
  } catch {
    // States list failed to load — fall back to no preselected state rather than
    // blocking the form; the user can still pick one manually from the dropdown.
    return undefined;
  }
};
